import { Navigate } from 'react-router-dom';
import useAuthStore, { isProfileComplete } from '../store/useAuthStore';
import { PATHS } from './navConfig';

/* Auth screens are for signed-out users — an active session goes straight to
   the dashboard (e.g. reloading or revisiting /login while logged in), or back
   into sign-up when the account never finished it. */
export default function PublicOnlyRoute({ children }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const user = useAuthStore((s) => s.user);
  if (isAuthenticated) {
    return <Navigate to={isProfileComplete(user) ? PATHS.DASHBOARD : PATHS.SIGNUP} replace />;
  }
  return children;
}
